import { render, staticRenderFns } from "./TaxonomyUrls.vue?vue&type=template&id=3071f790&"
import script from "./TaxonomyUrls.vue?vue&type=script&lang=js&"
export * from "./TaxonomyUrls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports